export const getParams = () => {
    const queryParams = new URLSearchParams(window.location.search);
    try {       
        const skuId = queryParams.get('sku_id');
        let skuName = queryParams.get('sku_name')
        let enterpriseId = queryParams.get('enterprise_id')
        let params = skuId ? {skuId} : {skuName,enterpriseId}
        return {params}
    } catch (error) {
        
    }

}